import { render, staticRenderFns } from "./NuovoMenu.vue?vue&type=template&id=6a1bbc77&"
import script from "./NuovoMenu.vue?vue&type=script&lang=js&"
export * from "./NuovoMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports